import styled from 'styled-components';

// 스테이지 선택 버튼필드 + 규격 적재 페이지 이동 버튼을 같은 레벨(한 줄)에 배치
export const PageHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 0 10px;
    margin-top: 20px;

    .stageSlot { min-width: 0; }
    /* WegetStageSelection 컨테이너가 자체 margin-top/padding을 갖고 있어 헤더에서 간격을 소유하도록 리셋 */
    .stageSlot > div { margin-top: 0; padding: 0; }
`;

// 규격 적재는 모든 스테이지 공유이므로 스테이지 선택과 같은 레벨에서 페이지를 전환한다.
export const StandardNavButton = styled.button`
    flex-shrink: 0;
    height: 40px;
    padding: 0 14px;
    border: 1px solid #cbd5e1;
    background: #fff;
    color: #334155;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s;

    &:hover { background: #f1f5f9; }

    &.active {
        border-color: #2563eb;
        background: #2563eb;
        color: #fff;
    }
`;
